// Every show/hide field of a print config, in the order of the Print Config form.
// Generated from Settings/PrintConfig.js: { key: <saved field>, label: default name }
export const PRINT_SECTIONS = [
  {
    title: "Store Information",
    fields: [
      { key: "StoreCode", label: "Store Code" },
      { key: "StoreName", label: "Store Name" },
      { key: "StorePhoneNo", label: "Phone No" },
      { key: "StoreEmailID", label: "Email ID" },
      { key: "StoreAddressLine1", label: "Address Line 1" },
      { key: "StoreAddressLine2", label: "Address Line 2" },
      { key: "StoreAddressCity", label: "City" },
      { key: "StoreAddressState", label: "State" },
      { key: "StoreAddressPostalCode", label: "Postal Code" },
      { key: "StoreAddressCountry", label: "Country" },
      { key: "StoreCustomField1", label: "Custom Field 1" },
      { key: "StoreCustomField2", label: "Custom Field 2" },
      { key: "StoreCustomField3", label: "Custom Field 3" },
      { key: "StoreCustomField4", label: "Custom Field 4" },
      { key: "StoreCustomField5", label: "Custom Field 5" },
      { key: "StoreCustomField6", label: "Custom Field 6" }
    ]
  },
  {
    title: "Customer Information",
    fields: [
      { key: "CustomerCode", label: "Customer Code" },
      { key: "CustomerName", label: "Customer Name" },
      { key: "CustomerPhoneNo", label: "Phone No" },
      { key: "CustomerEmailID", label: "Email ID" },
      { key: "CustomerBillingAddress", label: "Billing Address" },
      { key: "CustomerDeliveryAddress", label: "Delivery Address" },
      { key: "CustomerCustomField1", label: "Custom Field 1" },
      { key: "CustomerCustomField2", label: "Custom Field 2" },
      { key: "CustomerCustomField3", label: "Custom Field 3" },
      { key: "CustomerCustomField4", label: "Custom Field 4" },
      { key: "CustomerCustomField5", label: "Custom Field 5" },
      { key: "CustomerCustomField6", label: "Custom Field 6" }
    ]
  },
  {
    title: "Transaction",
    fields: [
      { key: "TransactionNo", label: "No" },
      { key: "TransactionDate", label: "Date" },
      { key: "TransactionTotalQty", label: "Total Qty" },
      { key: "TransactionDiscount", label: "Discount" },
      { key: "TransactionTaxSummary", label: "Tax Summary" },
      { key: "TransactionTotal", label: "Total" },
      { key: "TransactionPaid", label: "Paid" },
      { key: "TransactionBalance", label: "Balance" },
      { key: "TransactionRoundOff", label: "Round off" },
      { key: "TransactionAmountInWordsf", label: "Amount" },
      { key: "TransactionPaymentMode", label: "Payment Mode" },
      { key: "TransactionNotes", label: "Notes" }
    ]
  },
  {
    title: "Transaction Details",
    fields: [
      { key: "TransactionDetailsSrNo", label: "Sr. No." },
      { key: "TransactionDetailsSKU", label: "SKU" },
      { key: "TransactionDetailsItemName", label: "Item Name" },
      { key: "TransactionDetailsEmployeeName", label: "Employee" },
      { key: "TransactionDetailsNotes", label: "Notes" },
      { key: "TransactionDetailsItemDescription", label: "Item Description" },
      { key: "TransactionDetailsBarcode", label: "Barcode" },
      { key: "TransactionDetailsHSN", label: "HSN/SAC" },
      { key: "TransactionDetailsMRP", label: "MRP" },
      { key: "TransactionDetailsRetailPrice", label: "Retail Price" },
      { key: "TransactionDetailsBasePrice", label: "Base Price" },
      { key: "TransactionDetailsSupplyPrice", label: "Supply Price" },
      { key: "TransactionDetailsQty", label: "Qty" },
      { key: "TransactionDetailsSubTotal", label: "Sub Total" },
      { key: "TransactionDetailsBasePriceTotal", label: "Base Price Total" },
      { key: "TransactionDetailsDiscountPercentage", label: "Dis %" },
      { key: "TransactionDetailsDiscountAmount", label: "Dis Amt" },
      { key: "TransactionDetailsTax", label: "Tax" },
      { key: "TransactionDetailTaxAmount", label: "Tax Amount" },
      { key: "TransactionDetailsTotal", label: "Total" }
    ]
  }
];

const FIELD_KEYS = PRINT_SECTIONS.reduce(
  (keys, section) =>
    keys.concat(
      ...section.fields.map((f) => [f.key + "Display", f.key + "DisplayName"])
    ),
  []
);

// Every field on, for a registration with no template to copy from
export const DEFAULT_FIELDS = PRINT_SECTIONS.reduce((fields, section) => {
  section.fields.forEach((f) => {
    fields[f.key + "Display"] = true;
    fields[f.key + "DisplayName"] = f.label;
  });
  return fields;
}, {});

// Everything Customize can change on a print config
export const SETTING_KEYS = [
  ...FIELD_KEYS,
  "HeaderText",
  "HeaderImage",
  "FooterText",
  "FooterImage",
  "PrintHeight",
  "PrintOrientation"
];
